<div class="program-matrix-radio card">
  <h4>{{ '' }}</h4>
  <span
    class="label-highlight"
    *ngIf="nodes && nodes[0]?.description"
    [innerHTML]="nodes[0]?.description"
  ></span>

  <div class="program-matrix-radio__groups">
    @if(isMobile) {
    <div
      class="program-matrix-radio__group"
      *ngFor="let chain of nodes; let i = index"
      [ngClass]="{
        'program-matrix-radio__group--no-border': i === nodes.length - 1
      }"
    >
      <h5>{{ chain.labelText }}</h5>
      <mat-radio-group class="program-matrix-radio__radio-group">
        <mat-radio-button
          *ngFor="let item of chain?.values"
          [value]="item.value"
          (click)="$event.stopPropagation()"
          (change)="selectItem(chain, item.value)"
          ><span (click)="$event.stopPropagation()">
            {{ item.label || item.name }}
          </span></mat-radio-button
        >
      </mat-radio-group>
    </div>
    } @else {
    <table class="program-matrix-radio__table">
      <thead>
        <tr>
          <th class="program-matrix-radio__table-th--empty"></th>
          <th *ngFor="let col of headerColumns">
            <span>{{ col.label }}</span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let chain of nodes">
          <td>
            <span class="program-matrix-radio__label-title">
              {{ chain.labelText }}
            </span>
          </td>

          <td *ngFor="let col of headerColumns">
            <div class="program-matrix-radio__table-td-body">
              <ng-container
                *ngIf="
                  isOptionAvailableForNode(chain, col.value);
                  else emptyCell
                "
              >
                <mat-radio-button
                  [name]="'row-' + chain.id"
                  [value]="col.value"
                  [checked]="selectedByNode[chain.id] === col.value"
                  (change)="selectItem(chain, col.value)"
                  (click)="$event.stopPropagation()"
                ></mat-radio-button>
              </ng-container>

              <ng-template #emptyCell>
                <span class="program-matrix-radio__empty">&mdash;</span>
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    }
  </div>
</div>
